var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 18.583,
    viewBox: "0 0 16 18.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M6.485,2.583V-4.646H9.5V2.583H16V-11.893L7.991-16,0-11.893V2.583ZM5.166,1.264H1.319V-11.094l6.671-3.419,6.671,3.419V1.264H10.815V-5.965H5.166Z",
    transform: "translate(0 16)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656",
    transform: "translate(0 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654",
    transform: "translate(0 -16)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M-5-21H22.614V9.2H-5Z",
    transform: "translate(-0.807 15.193)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeblack);
export default __webpack_public_path__ + "static/media/homeblack.e7846df837a78dde9e5c6506f6d9ba6c.svg";
export { ForwardRef as ReactComponent };